import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Box } from 'roo-ui/components';
import OccupantPicker from 'components/OccupantPicker';
import DatePicker from 'components/DatePicker';
import { hashObject } from 'lib/hash';
import { getQuery } from 'store/propertyAvailability/propertyAvailabilitySelectors';
import { updateQuery as updateQueryAction } from 'store/propertyAvailability/propertyAvailabilityActions';

const labelOptions = { color: 'greys.alto' };

const withKey = (props) => ({ key: hashObject(props), ...props });

const SearchControls = () => {
  const query = useSelector(getQuery);
  const dispatch = useDispatch();

  const occupantQueryProps = withKey({ occupants: { adults: query.adults, children: query.children, infants: query.infants } });
  const dateQueryProps = withKey({ selectedDates: { startDate: query.checkIn, endDate: query.checkOut } });

  const updateQuery = useCallback(
    (query) => {
      dispatch(updateQueryAction(query));
    },
    [dispatch],
  );

  return (
    <Flex justifyContent="center">
      <Box mr={4} data-testid="stay-date-picker" flexBasis={['200px', '400px']}>
        <DatePicker {...dateQueryProps} labelOptions={labelOptions} updateQuery={updateQuery} anchorX="left" />
      </Box>

      <Box flexBasis={['85px', '150px']}>
        <OccupantPicker {...occupantQueryProps} labelOptions={labelOptions} updateQuery={updateQuery} />
      </Box>
    </Flex>
  );
};

export default SearchControls;
